import SectionHeading from "./SectionHeading";
import { highlights, libraryMetrics } from "@/mocks/anime";

export default function StatsSection() {
  return (
    <section id="stats" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="站点能力一览"
        title="为什么把三个片库放在同一页"
        desc="追番与补番的诉求本来就不一样：有人只想快速跟上新集，有人想一次补完整季，有人只想睡前看一集。与其分开做三套入口，不如把信息集中，让你少走一步。"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
        {highlights.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className={`${item.icon} text-2xl`} />
            </span>
            <h3 className="mt-4 font-heading text-2xl text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 lg:grid-cols-4">
        {libraryMetrics.map((metric) => (
          <div key={metric.label} className="bg-background-50 px-5 py-6 text-center">
            <p className="font-heading text-4xl text-primary-600">
              {metric.value}
              <span className="ml-1 text-base text-foreground-500">{metric.unit}</span>
            </p>
            <p className="mt-1.5 text-xs text-foreground-500">{metric.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}